import * as v from 'valibot';
export const zigbeeGUITemperatureSchema = v.object({
    min: v.number(),
    max: v.number(),
});
